var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mx-auto mt-10"},[_vm._v("У Вас недостаточно прав для доступа")])
}
var staticRenderFns = []

export { render, staticRenderFns }